import { RemoteGetUsersOnline } from 'data/usecases';
import { makeApiUrlUsersOnline } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetUsersOnline = (): RemoteGetUsersOnline => {
  return new RemoteGetUsersOnline(
    makeApiUrlUsersOnline(),
    makeAxiosHttpClient(),
  );
};
